import React, { Component } from 'react';
import { Spinner } from '../../../components/Spinner/spinner';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { toast } from 'react-toastify';

import PrimusHandler from '../../../api/primusHandler';
import './handleStripeResponse.css';
import './main.css';
import { AppContainer, AppWrapper } from './styles';

class HandleStripeResponse extends Component {
  state = {
    isTransactionSuccessful: false,
    loader: true,
    transactionDetails: null,
    isDemoConverted: false,
  };

  componentDidMount() {
    if (this.props.match.params && this.props.match.params.paymentStatus === 'true') {
      PrimusHandler.sendRequest({
        _handler: 'set-payment-transaction',
        isReact: true,
        paymentDetails: this.props.match.params,
      });
    } else if (this.props.match.params && this.props.match.params.paymentStatus === 'false') {
      PrimusHandler.sendRequest({
        _handler: 'set-payment-transaction',
        isReact: true,
        operation: 'handleFailedTransaction',
        paymentDetails: this.props.match.params,
      });
    } else {
      this.setState({
        loader: false,
        isTransactionSuccessful: false,
      });
    }
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.paymentDetails && props.paymentDetails.success) {
      if (props.paymentDetails.isFailedTransactionUpdated) {
        this.setState({
          loader: false,
          isTransactionSuccessful: false,
        });
      } else {
        this.setState({
          loader: false,
          isTransactionSuccessful: true,
          transactionDetails: props.paymentDetails.data ? props.paymentDetails.data : null,
          isDemoConverted: props.paymentDetails.data && props.paymentDetails.data.isDemoConverted ? true : false,
        });
      }
    } else if (props?.paymentDetails?.message === 'Payment already updated') {
      toast.error('Payment already updated');
      this.props.history.push('/payments');
    } else if (props.paymentDetails) {
      this.setState({
        loader: false,
        isTransactionSuccessful: false,
      });
    }
  }

  renderSuccessfulTransaction() {
    return (
      <AppContainer>
        <AppWrapper>
          <div className="transaction-wrapper">
            <div className="transaction-container">
              <div>
                <h3>Transaction Successful</h3>
              </div>
              <div className="mt-3">
                {this.state.isDemoConverted ? (
                  <h4>Thank you for purchasing tests - Your account has been activated</h4>
                ) : (
                  <h4>Thank you for purchasing tests - the test credits have been added to your account.</h4>
                )}
              </div>
            </div>
            <div className="button-container">
              <Button
                className="transaction-button"
                color="secondary"
                onClick={() => this.props.history.push('/payments')}
              >
                OK
              </Button>
            </div>
          </div>
        </AppWrapper>
      </AppContainer>
    );
  }

  renderUnsuccessfulTransaction() {
    return (
      <AppContainer>
        <AppWrapper>
          <div className="transaction-wrapper">
            <div className="transaction-container">
              <div>
                <h3>Transaction failed</h3>
              </div>
              <div className="mt-3">
                <h4>Please try again</h4>
              </div>
            </div>
            <div className="button-container">
              <Button
                className="transaction-button"
                color="secondary"
                onClick={() => this.props.history.push('/plans')}
              >
                OK
              </Button>
            </div>
          </div>
        </AppWrapper>
      </AppContainer>
    );
  }

  renderTransaction() {
    if (this.state.isTransactionSuccessful) {
      return this.renderSuccessfulTransaction();
    } else {
      return this.renderUnsuccessfulTransaction();
    }
  }

  render() {
    return (
      <div>
        {this.state.loader ? (
          <AppContainer>
            <AppWrapper>
              <Spinner
                title="Please wait while your payment is processing"
                text="Do not refresh / reload the page until processing is done..."
              />
            </AppWrapper>
          </AppContainer>
        ) : (
          this.renderTransaction()
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    paymentDetails: state.data['set-payment-transaction'],
  };
};

export default connect(mapStateToProps, null)(HandleStripeResponse);
